import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "concourse-filter-bar",
  templateUrl: "./filter-bar.component.html",
  styleUrls: ["./filter-bar.component.scss"],
})
export class FilterBarComponent implements OnInit, OnChanges {
  columnName: string = "projectname";
  sortingOrder: string = "ASC";
  @Input("columns") sortingOptions = [];
  @Input("dataSource") dataSource = [];
  @Output("onSortFilter") sortFilter = new EventEmitter<any>();
  filteredData = [];
  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["dataSource"]) {
      this.sortData(this.columnName, this.sortingOrder);
    }
  }

  sortData(sortBy, sortOrder) {
    this.columnName = sortBy;
    this.sortingOrder = sortOrder;
    this.filteredData = this.sortByKey(this.dataSource, sortBy, sortOrder);
    this.sortFilter.emit(this.filteredData);
  }

  sortByKey(array, attributeName, order = "ASC") {
    return array.sort(function (a, b) {
      var x = a[attributeName];
      var y = b[attributeName];
      if (attributeName == 0 || attributeName == 1 || attributeName == 2) {
        if (order == "ASC")
          return a["projecttype"] == attributeName
            ? -1
            : b["projecttype"] == attributeName
            ? 1
            : 0;
        else
          return a["projecttype"] == attributeName
            ? -1
            : b["projecttype"] == attributeName
            ? 0
            : 1;
      } else {
        //normal case

        //attribute check in normal case
        if (attributeName == "active/inactive") {
          if (order == "ASC") return a["inactive"] == 1 ? -1 : 0;
          else return a["inactive"] == 0 ? -1 : 1;
        } else if (
          attributeName.includes("date") ||
          attributeName.includes("expireson") ||
          attributeName.includes("createdon")
        ) {
          x = new Date(a[attributeName]).getTime() || a[attributeName];
          y = new Date(b[attributeName]).getTime() || b[attributeName];
        } else if (
          attributeName == "createdby" ||
          attributeName == "acquisitioncode"
        ) {
          x = a[attributeName]?.name || "";
          y = b[attributeName]?.name || "";
        }

        if (typeof x === "string" || typeof y === "string") {
          x = x !== null && x !== undefined ? x.toLowerCase() : "";
          y = y !== null && y !== undefined ? y.toLowerCase() : "";
        }

        if (order == "ASC") return x < y ? -1 : x > y ? 1 : 0;
        else return x > y ? -1 : x < y ? 1 : 0;
      }
    });
  }
}
